import { useCallback } from 'react';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { MonetaryAmountOutput } from '@sorare/core/src/hooks/useMonetaryAmount';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';
import { fromWei } from '@sorare/core/src/lib/wei';

type Props = {
  sport: Sport;
  monetaryAmount: MonetaryAmountOutput;
  fiatPayment: boolean;
  objectId: string;
};

const usePaymentBoxEvents = ({
  monetaryAmount,
  fiatPayment,
  sport,
  objectId,
}: Props) => {
  const track = useEvents();

  const trackConfirmPurchaseForm = useCallback(() => {
    track('Confirm Purchase Form', {
      ethAmount: fromWei(monetaryAmount.wei),
      eurAmount: monetaryAmount.eur,
      fiatPayment,
      sport,
      offerId: objectId,
    });
  }, [
    track,
    monetaryAmount.wei,
    monetaryAmount.eur,
    fiatPayment,
    sport,
    objectId,
  ]);

  return {
    trackConfirmPurchaseForm,
  };
};

export default usePaymentBoxEvents;
